"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var dealerSelectorStyles_1 = require("./dealerSelectorStyles");
var DealersListContainer_1 = require("./dealerListContainer/DealersListContainer");
var DealersMap_1 = require("./dealersMap/DealersMap");
var Routes_1 = require("../../../../../common/enum/Routes");
var react_router_1 = require("react-router");
var MinimalLoader_1 = require("../../../../../common/components/presentation/MinimalLoader/MinimalLoader");
var ThemedErrorMessage_1 = require("../../../../../common/components/presentation/Error/ThemedErrorMessage");
var useDealerSelectorDataPrep_1 = require("../../hooks/useDealerSelectorDataPrep");
var useSortDealers_1 = require("../../hooks/useSortDealers");
var useCheckoutContext_1 = require("../../../../common/hooks/useCheckoutContext");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var ContinueButton_1 = require("../../../../common/components/continueButton/ContinueButton");
var errorHandler_1 = require("../../../../../common/service/errorHandler");
var usePlatformConfig_1 = require("../../../../../common/react/usePlatformConfig");
var globalTypes_1 = require("../../../../../__generated__/globalTypes");
var useJourneyStepsContext_1 = require("../../../../checkout4/hooks/useJourneyStepsContext");
var dxpDigitalDataAssignment_1 = require("../../../../../../../common/utilities/dxpDigitalDataAssignment");
var customDatalayerInterface_1 = require("../../../../../../../common/utilities/customDatalayerInterface");
var dxpProducts_1 = require("../../../../../../../common/constants/dxpProducts");
var dxpDataLayerHandler_1 = require("../../../../common/utils/dxpDataLayerHandler");
var JourneyStepsRoutes_1 = require("../../../../checkout4/enum/JourneyStepsRoutes");
var DealerSelector = function () {
    var _a, _b, _c, _d;
    var styles = dealerSelectorStyles_1.default();
    var _e = usePlatformConfig_1.default().platformConfig, checkout = _e.checkout, isCheckout4Enabled = _e.platformFeatures.isCheckout4Enabled, dxpDataLayer = _e.dxpDataLayer;
    var history = react_router_1.useHistory();
    var _f = useDealerSelectorDataPrep_1.default(), dealers = _f.dealers, defaultDealer = _f.defaultDealer, setSelectedDealerId = _f.setSelectedDealerId, selectedDealerId = _f.selectedDealerId, loading = _f.loading, error = _f.error, selectDealerMutation = _f.selectDealerMutation, disabled = _f.disabled, customerPreferredDealerId = _f.customerPreferredDealerId;
    var sortedDealers = useSortDealers_1.default(dealers);
    var _g = useCheckoutContext_1.default(), deal = _g.deal, refetch = _g.refetch, stockType = _g.stockType;
    var handleNext = useJourneyStepsContext_1.default().handleNext;
    var dealerIdSavedOnDeal = (_b = (_a = deal) === null || _a === void 0 ? void 0 : _a.dealer) === null || _b === void 0 ? void 0 : _b.externalId;
    var _h = checkout || {}, disableDealerSelect = _h.disableDealerSelect, showDealerJourneyForDistributionStock = _h.showDealerJourneyForDistributionStock;
    var disableDealerSelection = disableDealerSelect && stockType === globalTypes_1.StockType.dealer;
    var isDistributionStock = (_d = (_c = deal) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.isDistributionStock;
    var skipDealerJourneyIfDistributionStock = isDistributionStock && !showDealerJourneyForDistributionStock;
    var skipDealerJourneyIfRetailStock = !isDistributionStock && showDealerJourneyForDistributionStock;
    react_1.useEffect(function () {
        var _a;
        if (skipDealerJourneyIfDistributionStock || (skipDealerJourneyIfRetailStock && ((_a = deal) === null || _a === void 0 ? void 0 : _a.car.stock))) {
            clickContinueCTA();
        }
    }, []);
    react_1.useEffect(function () {
        if (!selectedDealerId && !!customerPreferredDealerId) {
            setSelectedDealerId(customerPreferredDealerId);
        }
    }, [selectedDealerId, customerPreferredDealerId]);
    var selectDealer = function (id) {
        var _a, _b, _c, _d, _e;
        if (!selectedDealerId || selectedDealerId !== id) {
            setSelectedDealerId(id);
            var dealerLabel = (_a = dealers.find(function (dealer) { return dealer.externalId === id; })) === null || _a === void 0 ? void 0 : _a.label;
            if ((dxpDataLayer && ((_c = (_b = deal) === null || _b === void 0 ? void 0 : _b.dealer) === null || _c === void 0 ? void 0 : _c.label)) || dealerLabel) {
                dxpDigitalDataAssignment_1.default(__assign(__assign({ event: customDatalayerInterface_1.DxpDataLayerEvent.CONFIGURATOR, eventName: customDatalayerInterface_1.DxpDataLayerEventNames.CNF_DEALERS_CLICKED, pageTitle: document.title, DXPProduct: dxpProducts_1.default.checkout, dealerPreference: ((_e = (_d = deal) === null || _d === void 0 ? void 0 : _d.dealer) === null || _e === void 0 ? void 0 : _e.label) || dealerLabel || '' }, dxpDataLayerHandler_1.formatDataLayerDeal(deal)), { nextSteps: dxpDataLayerHandler_1.getSaveEnquiryFormNextSteps(), stepName: JourneyStepsRoutes_1.JourneyStepsRoutes.DEALER.replace('/', '') }));
            }
        }
        if (selectedDealerId && selectedDealerId === id) {
            setSelectedDealerId(null);
        }
    };
    var clickContinueCTA = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!(dealerIdSavedOnDeal !== selectedDealerId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, selectDealerMutation()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (isCheckout4Enabled) {
                        handleNext();
                        refetch && refetch();
                    }
                    else {
                        history.push(__assign(__assign({}, history.location), { pathname: Routes_1.Routes.REQUEST_QUOTE }));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    errorHandler_1.default.handleError(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    if (loading) {
        return <MinimalLoader_1.default />;
    }
    if (error) {
        return <ThemedErrorMessage_1.default fullPage={true} error={error}/>;
    }
    return (<>
      <core_1.Box className={styles.container} data-test="container:checkout:dealer">
        <DealersListContainer_1.default dealers={sortedDealers} selectedDealerId={selectedDealerId} selectDealerId={selectDealer} disableDealerSelection={disableDealerSelection}/>
        <DealersMap_1.default defaultDealer={defaultDealer} dealers={sortedDealers} selectedDealerId={selectedDealerId} selectDealerId={selectDealer} disableDealerSelection={disableDealerSelection}/>
      </core_1.Box>
      <core_1.Box className={styles.actionButtonsContainer}>
        <ContinueButton_1.default onClick={clickContinueCTA} testId={'dealer:continue:button'} disabled={disabled}>
          <Translation_1.default id={'trans__checkout__dealers_page__continue_CTA'}/>
        </ContinueButton_1.default>
      </core_1.Box>
    </>);
};
exports.default = DealerSelector;
